import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, submit } from 'redux-form/immutable';
import { TextField } from 'redux-form-material-ui';
import FlatButton from 'material-ui/FlatButton';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ReduxDialog from '../Common/ReduxDialog';

import commonStyles from '../styles';
import styles from './styles';

const validate = (values) => {
  const errors = {};
  if (!values.get('tag')) {
    errors.tag = 'Required';
  }
  return errors;
};

class TagDialog extends React.Component {
  static propTypes = {
    onRequestClose: PropTypes.func.isRequired,
  };

  state = {};

  render() {
    const { handleSubmit } = this.props;
    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={() => this.props.onRequestClose()}
      />,
      <FlatButton
        label="Save"
        primary
        keyboardFocused
        onClick={() => this.props.dispatch(submit('Tag'))}
      />,
    ];

    return (
      <ReduxDialog
        name="tag"
        title="Add Tag"
        actions={actions}
        onRequestClose={this.handleClose}
        bodyStyle={styles.body}
      >
        <form onSubmit={handleSubmit}>

          <Field
            name="tag"
            floatingLabelText="Tag"
            floatingLabelFixed
            fullWidth
            component={TextField}
            style={commonStyles.input}
          />
        </form>
      </ReduxDialog>
    );
  }
}

const form = reduxForm({
  form: 'Tag',  // a unique identifier for this form
  enableReinitialize: true,
  validate,
  onSubmit: (values, dispatch, props) => {
    props.onRequestClose(values.toJS().tag);
  },
})(TagDialog);

//export default form;

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
  }, dispatch);
}
//
// function mapStateToProps(state) {
//   return {
//   };
// }
//
export default connect(null, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/TagDialog/index.js